import momentJalaali from 'moment-jalaali';
import { FraudEvidence, FraudEvidenceRow, FraudRoutePoint } from './fraud-case-details.models';

export function formatCaseDate(value: string): string {
  const date = momentJalaali(value);
  return date.isValid() ? date.format('jYYYY/jMM/jDD HH:mm') : '—';
}

export function buildEvidenceRows(items: FraudEvidence[]): FraudEvidenceRow[] {
  const time = (value: string): string => value?.match(/[T ](\d{2}:\d{2})/)?.[1] || '—';
  return items.map(item => {
    const insufficient = item.strEvaluationStatus === 'InsufficientData';
    const suspicious = item.bSuspicious === true || Number(item.bSuspicious) === 1;
    return {
      ...item,
      timeRange: `${time(item.dtStartDate)} – ${time(item.dtEndDate)}`,
      evaluationLabel: insufficient ? 'داده ناکافی' : suspicious ? 'مشکوک' : 'غیرمشکوک',
      evaluationClass: insufficient ? 'unknown' : suspicious ? 'ok' : 'bad'
    };
  });
}

export function buildRouteSegments(points: FraudRoutePoint[]): FraudRoutePoint[][] {
  const seen = new Set<string>();
  const valid = points.filter(point => {
    const lat = Number(point.dLatitude), lon = Number(point.dLongitude);
    const key = `${point.dtDateTime}|${lat}|${lon}`;
    if (point.dLatitude == null || point.dLongitude == null || seen.has(key) || !Number.isFinite(lat) || !Number.isFinite(lon) ||
      Math.abs(lat) > 90 || Math.abs(lon) > 180 || (lat === 0 && lon === 0) ||
      !point.dtDateTime || !momentJalaali(point.dtDateTime).isValid()) return false;
    seen.add(key);
    return true;
  }).sort((a, b) => momentJalaali(a.dtDateTime).valueOf() - momentJalaali(b.dtDateTime).valueOf());
  const segments: FraudRoutePoint[][] = [];
  valid.forEach((point, index) => {
    if (!index || momentJalaali(point.dtDateTime).diff(momentJalaali(valid[index - 1].dtDateTime), 'seconds', true) > 180) {
      segments.push([]);
    }
    segments[segments.length - 1].push(point);
  });
  return segments;
}
